import React from "react";
import exportImage from '../../../components/_images/export.svg'
import {useAxiosSetup} from "../../Api";
import {prepareFilters} from "./RequestSupport";
import {useAppState} from "../../AppStateContext";


function ExportButton(props) {
    const api = useAxiosSetup();
    const {appState, updateAppState} = useAppState()

    function exportData(name) {
        api.get(props.exportUrl, {params: {
                    ...prepareFilters(appState.filterData),
                }}
            ).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            // use backend filename if available, otherwise fallback
            const contentDisposition = response.headers["content-disposition"];
            let fileName = "export.csv";
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="(.+)"/);
                if (match.length > 1) fileName = match[1];
            }

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        })
    }

    return (
        <div style={{maxWidth: '200px', marginRight: '20px'}}>
            <button type="button" className="btn btn-outline-primary btn-md bigButton" style={{"opacity": "0.8"}} onClick={exportData}>
                <img src={exportImage} alt="Export" className="buttonImage" style={{width: '14px', height: '14px', marginRight: '5px'}}/>
            Export</button >
        </div>
    )
}

export default ExportButton
